import { User } from "shared-types";
import { useMemo } from "react";
import { ColumnDef, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { UserFragment } from "../../_generated/graphql";


interface UsersTableProps {
	data: UserFragment[];
	onEditClick: (userId: string) => void;
	onDeleteClick: (userId: string, name: string) => void;
}

export const UsersTable = ({ data, onEditClick, onDeleteClick }: UsersTableProps) => {

	const rowData = useMemo(() => data, [ data ]);


	const columns = useMemo<ColumnDef<UserFragment>[]>(
		() => [
			{
				header: 'First Name',
				accessorKey: 'firstName'
			},
			{
				header: 'Last Name',
				accessorKey: 'lastName'
			},
			{
				header: 'Email',
				accessorKey: 'email'
			},
			{
				header: 'Role',
				accessorKey: 'role'
			},
			{
				header: 'Action',
				cell: props => {
					return (
						<div className="">
							<button className="btn"
									onClick={ () => onEditClick(props.row.original._id!) }>Edit</button>
							<button className="btn" color={ "error" }
									onClick={ () => onDeleteClick(props.row.original._id!, `${props.row.original.firstName} ${props.row.original.lastName}`) }
									>Delete</button>
						</div>
					)
				}
			}
		],
		[ onEditClick, onDeleteClick ])

	const table = useReactTable({
		data: rowData,
		columns,
		// pageCount: dataQuery.data?.pageCount ?? -1,
		// state: {
		// 	pagination,
		// },
		// onPaginationChange: setPagination,
		getCoreRowModel: getCoreRowModel(),
		manualPagination: true,
		// getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
		debugTable: true,
	});


	return (

		<div>
			<table>
				<thead>
					{ table.getHeaderGroups().map(headerGroup => (
						<tr key={ headerGroup.id }>
							{ headerGroup.headers.map(header => {
								return (
									<th key={ header.id } colSpan={ header.colSpan }>
										{ header.isPlaceholder ? null : (
											flexRender(
												<span>
													{/*{ header.column.columnDef.header }*/}
													{ header.column.columnDef.header!.toString() }
												</span>,
												header.getContext()
											)
										) }
									</th>
								)
							}) }
						</tr>
					)) }
				</thead>
				<tbody>
					{ table.getRowModel().rows.map(row => {
						return (
							<tr key={ row.id }>
								{ row.getAllCells().map(cell => {
									return (
										<td key={ cell.id }>
											{ flexRender(
												cell.column.columnDef.cell,
												cell.getContext()
											) }
										</td>
									)
								}) }
							</tr>
						)
					}) }
				</tbody>
			</table>

		</div>

	);
};

